module.exports = __webpack_public_path__ + "img/notros-logo.be57a969.svg";